/* Component Dependencies */
var imageHeaderTextCtaAdvancedTemplate= require('templates/imageHeaderTextCtaAdvanced.hbs');
var AriesComponent = require('libs/aries-component');

var FadeInHandler = require('libs/fade-in-handler');
var $ = require('jquery');
var Popup = require('libs/popup');
var _ = require('lodash');

AriesComponent.create({
  type: 'imageHeaderTextCtaAdvanced',
  template: {
    'imageHeaderTextCtaAdvanced': imageHeaderTextCtaAdvancedTemplate
  },
  unBindEvents: function($) {
    $('*[data-component-id="' + this.$el.data('component-id') + '"]').off();
    $('*[data-component-id="' + this.$el.data('component-id') + '"] *').off();
  },
  bindEvents: function() {
    var _self = this,
    triggerElement = '.tile-photo-promo-container .m-photo-promo',
    options = $(triggerElement).data();
    FadeInHandler.init(triggerElement, options);

    if(_self.$el.find('.js-info-btn').hasClass('mi-popover')) {
      _self.registerPopup();
    }  
  },

  //Register Popup onButton Click
    registerPopup: function(url) {
      var hotelInfoPopup = new Popup ({
        selector: '.tile-photo-promo-container .m-photoPromo-text .js-info-btn.mi-popover',
        sourceBlock: '.modal-content',
        alternateCloseMarckup: true
      });
      hotelInfoPopup.register();
    }
});

